export const scrollToTarget = (target) => {
    if (window.__lenis) {
        window.__lenis.scrollTo(target, { offset: -72, duration: 1.4 });
    } else if (typeof target === "string") {
        document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
};

export const handleAnchor = (target) => (e) => {
    e.preventDefault();
    scrollToTarget(target);
};
